import React from 'react';

import {
  Tab,
  Tabs
} from '@mui/material';
import _ from 'lodash';



export interface ITabDef<TId extends string> {
  id: TId;
  label: string;
}

export interface IProps<TTabId extends string> {
  selectedTabId: TTabId;
  fullWidth?: boolean;
  disabled?: boolean;

  tabs: ReadonlyArray<ITabDef<TTabId>>;
  onClickTab: (id: TTabId) => void;
}

export const FC = <TTabId extends string>(
  props: IProps<TTabId> & { children?: React.ReactNode }
) => {

  const selectedIndex = React.useMemo(() =>
    _.findIndex(props.tabs, tab => tab.id === props.selectedTabId) ?? 0,
  [props.selectedTabId, props.tabs]);

  return (
    <Tabs
      variant={props.fullWidth ? 'fullWidth' : 'standard'}
      value={selectedIndex}
      onChange={(_, tabIndex) =>
        props.onClickTab(props.tabs[tabIndex].id as TTabId)
      }>
      {_.map(props.tabs, (tab, index) => (
        <Tab
          disabled={props.disabled}
          key={tab.id}
          tabIndex={index}
          label={tab.label}
          style={{
            color: index === selectedIndex ? 'white' : undefined
          }} />
      ))}
    </Tabs>
  );
};
